import { Checking } from './Checking'
 
  function getRandomElement(item) {
    let randIndex = Math.floor(Math.random() * item.length);
    return item.length > 0 && item[randIndex];
  }
  
  function filtrSearchMenu(arr, keyword) { 
    const keywordSearch = keyword.nameRu.toLowerCase();
    let idMenu = []
    const NewArray = arr.filter((item) => {
     return item.category.toLowerCase().includes(keywordSearch)
    })
    if(NewArray.length > 0) {  
      idMenu = NewArray.map(item=> {
       return  {_id: item._id,
         cal: item.calories.calories/item.servings
        }
      })
    } else {
      idMenu=[]
    } 
    return idMenu
  }
  
  function lastSearchMenu(arr, keyword, mix) {
     const keywordSearch = keyword.nameRu.toLowerCase(); 
     let idMenu = []
     const NewArray = arr.filter((item) => {
       const cal = item.calories.calories/item.servings 
       const category = item.category.toLowerCase().includes(keywordSearch)
       const result = mix ==='more' ?  category && cal > keyword.cal && cal < 2300 : category && cal < keyword.cal && cal > 0
       return result
     })
     if(NewArray.length > 0) {  
      idMenu = NewArray.map(item=> {
       return  {
         _id: item._id,
         cal: item.calories.calories/item.servings
        }
      })
    } else {
      idMenu=[]
    }
     return idMenu.length > 0 ? idMenu : []
   }
 
  //Формирование меню в зависимости от настроек пользователя
  export function menuCreate(currentUser, recipes, dateDay, ingredients ) { 
    let powerMode = currentUser.settings.powerMode //приемы пищи
    const maxCals = currentUser.settings.maxCals 
    let step = 100
    //подбирается рандомно рецепты в план
    function arr() {
      let arrCals =[] 
      let totalCals = 0
      let newArr = powerMode.reduce(function(target, key, index) {
        if (!key.boolean) {
          target[key.nameEn] = []
        } else if(key.boolean) {
          const filteredDish = key.dish.filter(s => s.boolean);
          let data = []; 
          // Обходим приемы пищи и добавлем в ниx блюда из настроек
          filteredDish.forEach((dish, i) => { 
            const randomData = filtrSearchMenu(recipes, dish);
            if (randomData.length > 0) {
              const randomElement = getRandomElement(randomData);
              arrCals.push({...dish, ...randomElement, type: key.nameEn });
              totalCals += randomElement.cal 
              data.push(randomElement);
            }
          })
         
            target[key.nameEn] = data
        }
        return target;
      }, {})  
      if(maxCals-totalCals > step || maxCals-totalCals < -step ) { 
        generateSets(totalCals)
      } 
      function generateSets(totalCals) {   
        let results = {}
        let count = 0 // счетчик запуска функции findSets
        let finishCals = totalCals
        let remains = maxCals - finishCals
        const arr = newArr 
        
        findSets(remains, arrCals)
        function findSets (remains, arrVal) { 
          count+=1
          if(count > 100) { // Если поиск рецептов удовл-х калорийности больше 100, то мы увеличиваем шаг погрешности на 100кал
            step+=100
            count = 0
          } 
          if(remains < step && remains > -step) { 
            results = arr
            return results
          }
          if(remains > step) { 
            let minValue = [...arrVal].sort((a, b) => a.cal - b.cal); 
              for (let i = 0; i < minValue.length; i++) { 
                let replace = {...minValue[i]}
                const randomData = lastSearchMenu(recipes, minValue[i], 'more');
                if (randomData.length > 0) {
                  const randomElement = getRandomElement(randomData);
                  const key = minValue[i].type  
                  arr[key] = arr[key].map(n=> n._id === minValue[i]._id ? randomElement : n) 
                  replace ={...replace, ...randomElement} 
                  minValue[i] = replace 
                  finishCals = minValue.reduce(function (currentSum, cal) {
                    return currentSum + cal.cal
                  }, 0) 
                  if(maxCals-finishCals < step && maxCals-finishCals > -step) {
                    findSets(maxCals-finishCals, minValue,)
                    break
                  } else if (maxCals-finishCals < -step){
                      findSets(maxCals-finishCals, minValue)
                      break
                  }
                }   
              } 
              if(maxCals - finishCals > step) {
                findSets(finishCals-maxCals, minValue)
              }
          } else if(remains < -step) {
            let maxValue = [...arrVal].sort((a, b) => b.cal - a.cal); 
            for (let i = 0; i < maxValue.length; i++) { 
              let replace = {...maxValue[i]} 
              const randomData = lastSearchMenu(recipes, maxValue[i], 'less');
              if (randomData.length > 0) {
                const randomElement = getRandomElement(randomData);
                const key = maxValue[i].type 
                arr[key] = arr[key].map(n=> n._id === maxValue[i]._id ? randomElement : n) 
                replace ={...replace, ...randomElement} 
                maxValue[i] = replace 
                finishCals = maxValue.reduce(function (currentSum, cal) {
                  return currentSum + cal.cal
                }, 0)   
                if(maxCals-finishCals < step && maxCals-finishCals > -step) {
                   findSets(maxCals-finishCals, maxValue)
                   break
                } else if (maxCals-finishCals > step){
                    findSets(maxCals-finishCals, maxValue)
                    break
                } 
              }
            }  
            if(maxCals - finishCals< -step) {
              findSets(maxCals - finishCals, maxValue)
            }
          }
        } 
         return results
      } 
      return newArr
    }
   
    //Учитывается периодичность готовки 1/2, 1/3, 1/1
    const periodicity = currentUser.settings.periodAn
    const how = [...dateDay]

     // если готовить каждый день
    if(periodicity === 'everyday') {
      for (let i = 0; i < how.length; i ++) {
        how[i] = {
          date: how[i].date,
          foodList: [],
          ...arr(),
        }
      }
    }  // если готовить 1 раз в 2 дня
    else if(periodicity === 'two') {
      for (let i = 0; i < how.length; i ++) {
        if (i % 2 === 0) {
          how[i] = {
            date: how[i].date,
            foodList: [],
            ...arr(),
          }
        } else {
            how[i] = {
              date: how[i].date,
              foodList: [],
              breakfast: how[i-1].breakfast,
              dinner: how[i-1].dinner,
              lateDinner: how[i-1].lateDinner,
              lunch: how[i-1].lunch,
              snack: how[i-1].snack,
              supper: how[i-1].supper,
            }  
          }
      }
    } // если готовить 1 раз в 3 дня
    else if(periodicity === 'three') {
      for (let i = 0; i < how.length; i ++) {
        if (i % 3 === 0) {
          how[i] = {
            date: how[i].date,
            foodList: [],
            ...arr(),
          }
        } else {
            how[i] = {
              date: how[i].date,
              foodList: [],
              breakfast: how[i-1].breakfast,
              dinner: how[i-1].dinner,
              lateDinner: how[i-1].lateDinner,
              lunch: how[i-1].lunch,
              snack: how[i-1].snack,
              supper: how[i-1].supper,
            }  
          }
      }
    }
     
    // Возвращается 
    return Checking(how, recipes, ingredients)
  }
